import { createContext } from 'react'

/**
 * Context containing form data for a task notification.
 */
export const TaskNotificationContext = createContext()

export default TaskNotificationContext
